import React from "react";
import { Switch } from "@headlessui/react";

export default function TableView({ showTableView, setShowTableView }) {
  return (
    <div className="">
      <div className="font-bold mb-1">Visa som tabell</div>
      <Switch
        checked={showTableView}
        onChange={setShowTableView}
        className={`${
          showTableView ? "bg-blue-600" : "bg-gray-200"
        } relative inline-flex h-6 w-11 items-center rounded-full`}
      >
        <span
          className={`${
            showTableView ? "translate-x-6" : "translate-x-1"
          } inline-block h-4 w-4 transform rounded-full bg-white`}
        />
      </Switch>
    </div>
  );
}
